import { t, Trans } from '@lingui/macro';
import { NoddiBasicCard, NoddiLink } from 'noddi-ui-web';
import { ContentWrapper } from 'noddi-ui-web/src/components/Elements/Layouts/ContentWrapper';
import { customerRoutes } from 'noddi-util';
import { useLocation, useParams } from 'react-router-dom';
import { TireOfferNextInstructions } from '../../../components/TireOffer/TireOfferNextInstructions';
import { BgImageContainer } from '../../BookingInfo/BgImageContainer';
import { DinteroErrorTypes } from '../../PaymentInfo/types';
import { getErrorTextBasedOnErrorType } from '../../PaymentInfo/utils';

export const TireOfferPaymentInfo = () => {
  const location = useLocation();
  const { sessionId } = useParams<{ sessionId: string }>();

  const searchParams = new URLSearchParams(location.search);

  const transactionId = searchParams.get('transaction_id');
  const error = searchParams.get('error') as DinteroErrorTypes;

  const isPaymentSuccessful = Boolean(transactionId) && error !== 'capture';
  return (
    <BgImageContainer>
      <ContentWrapper hideBackButton className='flex min-h-[60vh] items-center justify-center'>
        {isPaymentSuccessful ? (
          <div className='flex flex-col gap-6 xxs:gap-8 lg:gap-16'>
            <div>
              <p className='mb-4 font-bold text-3xl text-primary md:text-4xl'>
                {t`Your order is confirmed and paid!`} 🚀
              </p>
              <TireOfferNextInstructions />
              <p className='mt-4'>
                <Trans>In the meantime, if you have any questions, contact us at hei@noddi.no</Trans>
              </p>
              <NoddiLink className='mt-4 self-end' to={customerRoutes.homepage.getPath()}>
                <Trans>Close</Trans>
              </NoddiLink>
            </div>
          </div>
        ) : (
          <NoddiBasicCard className='flex w-full flex-col items-center gap-4 text-center'>
            <span className='font-bold text-2xl'>
              <Trans>Payment failed</Trans>
            </span>
            <span>{getErrorTextBasedOnErrorType(error)}</span>
            <NoddiLink className='w-full' to={customerRoutes.tireOfferConfirmation.getPath({ sessionId: sessionId! })}>
              <Trans>Try again</Trans>
            </NoddiLink>
          </NoddiBasicCard>
        )}
      </ContentWrapper>
    </BgImageContainer>
  );
};
